import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import UserManualNew from './user_manual_new';

export default function UserManualNewPopup({ open, onClose }) {
  const isNarrow = useMediaQuery('(max-width:1024px)');

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="user-manual-new" aria-describedby="user-manual-new-desc">
      <Box
        sx={{
          position: 'absolute',
          top: isNarrow ? 0 : '5%',
          left: isNarrow ? 0 : '5%',
          height: isNarrow ? '100%' : '90%',
          width: isNarrow ? '100%' : '90%',
          bgcolor: '#0d2147',
          boxShadow: 24,
          borderRadius: isNarrow ? 0 : 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CancelOutlinedIcon
          onClick={onClose}
          sx={{
            color: '#fff',
            backgroundColor: '#3F69F8',
            borderRadius: '50%',
            p: 0.5,
            top: isNarrow ? 10 : 'calc(5% - 12px)',
            right: isNarrow ? 10 : 'auto',
            left: isNarrow ? 'auto' : 'calc(95% - 13px)',
            height: 28,
            width: 28,
            cursor: 'pointer',
            position: 'fixed',
            zIndex: 1300,
            '&:hover': { backgroundColor: '#3357d6' },
          }}
        />
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            width: '100%',
            background: '#132d5a',
            overflow: 'hidden',
          }}
        >
          <UserManualNew />
        </Box>
      </Box>
    </Modal>
  );
}
